import { msg } from '../../../i18n/msg.ts';

/**
 * Các thông điệp hiển thị trong giao diện Trợ lý AI.
 * Mỗi thông điệp là một Msg (khóa + tham số): giao diện dịch lúc hiển thị, nên đổi ngôn ngữ là cập nhật ngay.
 */
export const AI_MESSAGES = {
  QUIZ_EMPTY_IMPORT: msg('ai:quiz.emptyImport'),
  /** Thông báo khi import câu hỏi thành công nhưng chỉ lưu vào kho. */
  QUIZ_IMPORT_SUCCESS: (count: number) => msg('ai:quiz.importSuccess', { count }),
  /**
   * Thông báo khi bộ câu hỏi vừa được mở lên bảng và vẫn được lưu vào kho.
   * Đây là luồng mặc định sau khi áp dụng kết quả từ AI Quiz Supporter.
   */
  QUIZ_IMPORT_ON_BOARD: (count: number) => msg('ai:quiz.importOnBoard', { count }),
  /** Thông báo khi mở câu hỏi đã lưu từ kho bài tập lên bảng. */
  QUIZ_OPENED_ON_BOARD: (count: number) => msg('ai:quiz.openedOnBoard', { count }),
  /** Kho bài tập từ chối lưu bộ câu hỏi - mạng hỏng hoặc máy chủ trả lỗi. */
  QUIZ_SAVE_FAILED: msg('ai:quiz.saveFailed'),
  /** Kho bài tập mở từ trang riêng, chưa có tiết dạy nào để mở bảng. */
  QUIZ_NO_BOARD: msg('ai:quiz.noBoard'),
} as const;

/**
 * Tiền tố và khóa lưu trữ cục bộ (localStorage)
 */
export const AI_STORAGE_KEYS = {
  CHAT_ID_PREFIX: 'ai-quiz-chat-id',
  CHAT_ID_GUEST: 'ai-quiz-chat-id-guest',
} as const;

/**
 * Bộ chọn CSS cho các phần tử có thể nhận focus trong hộp thoại (focus trap)
 */
export const DIALOG_FOCUSABLE_SELECTOR =
  'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';
